import React from "react";
import {
  Box,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Popover,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import {
  ArrowDropDown,
  Assignment,
  Email,
  IosShare,
  Phone,
  PhoneInTalk,
  PlaylistAdd,
  Textsms,
  WhatsApp,
} from "@mui/icons-material";
import { EmailComposeDialog } from "../MessagesDialogs/EmailCompose/EmailComposeDialog";
import { IActiviityProps } from "./Activity.types";


import { ManageBusinessTask } from "./BusinessTasks/ManageBusinessTask";
import {
  CallRightPanel,
} from "../MessagesDialogs/CallDialog/CallDialog";
import { WhatsAppRightPanel } from "../MessagesDialogs/WhatsAppDialog/WhatsAppDialog";
import { SmsRightPanel } from "../MessagesDialogs/SmsDialog/SmsDialog";

export const ActivityComTabs: React.FC<IActiviityProps> = (props) => {
  const {
    task,
    email,
    moduleInformation,
    phoneWhatsAppSMS,
    changeTab,
  } = props;

  const [openEmail, setOpenEmail] = React.useState(false);
  const [openTask, setOpentask] = React.useState(false);
  const [openContact, setOpenContact] = React.useState<string | null>(null);

  // React.useEffect(() => {
  //   dispatch(fetchBusinessTasksAsync(moduleInformation.moduleId));
  //   return () => {
  //     dispatch(clearActivityState());
  //   };
  // }, []);

  return (
    <>
      <Stack direction={"row"} spacing={1} flexWrap={"wrap"}>
        {task && (
          <Box>
            <ActivityMenuOption
              icon={<Assignment color="primary" />}
              label="Tasks"
              children={{
                label: "Tasks",
                menuItems: [
                  {
                    label: "Create Task",
                    icon: <PlaylistAdd />,
                    onClick: () => setOpentask(true),
                  },
                ],
              }}
            />
          </Box>
        )}
        {email && (
          <Box>
            <ActivityMenuOption
              icon={<Email color="disabled" />}
              label="Mail"
              children={{
                label: "Email",
                value: email.value,
                menuItems: [
                  {
                    label: "Send mail",
                    icon: <IosShare />,
                    onClick: () => setOpenEmail(true),
                  },
                ],
              }}
            />
          </Box>
        )}
        {phoneWhatsAppSMS && (
          <Box>
            <ActivityMenuOption
              icon={<PhoneInTalk color="error" />}
              label="Contact"
              children={{
                label: "Contact",
                value: phoneWhatsAppSMS,
                menuItems: [
                  {
                    label: "Phone",
                    icon: <Phone />,
                    onClick: () => setOpenContact("phone"),
                  },
                  {
                    label: "SMS",
                    icon: <Textsms />,
                    onClick: () => setOpenContact("sms"),
                  },
                  {
                    label: "WhatsApp",
                    icon: <WhatsApp />,
                    onClick: () => setOpenContact("whatsapp"),
                  },
                ],
              }}
            />
          </Box>
        )}
      </Stack>

      {openEmail && email && (
        <EmailComposeDialog
          open={openEmail}
          toEmail={email.value}
          onClose={() => setOpenEmail(false)}
          history={{
            module_name: moduleInformation.moduleName,
            module_code: moduleInformation.moduleId,
          }}
        />
      )}
      {openTask && (
        <ManageBusinessTask
          open={openTask}
          moduleInformation={moduleInformation}
          onClose={() => setOpentask(false)}
          changeTab={changeTab}
          onComplete={()=> {
            setOpentask(false)
            }}
        />
      )}
      {phoneWhatsAppSMS && openContact === "phone" && (
        <CallRightPanel
          open={true}
          mobileNumber={phoneWhatsAppSMS}
          onClose={() => setOpenContact(null)}
        />
      )}
      {phoneWhatsAppSMS && openContact === "whatsapp" && (
        <WhatsAppRightPanel
          open={true}
          mobileNumber={phoneWhatsAppSMS}
          onClose={() => setOpenContact(null)}
        />
      )}
      {phoneWhatsAppSMS && openContact === "sms" && (
        <SmsRightPanel
          open={true}
          mobileNumber={phoneWhatsAppSMS}
          onClose={() => setOpenContact(null)}
        />
      )}
    </>
  );
};

const ActivityMenuOption: React.FC<{
  icon: any;
  label: string;
  children?: {
    label: string;
    value?: string;
    menuItems: { label: string; icon: React.ReactNode; onClick: () => void }[];
  };
}> = ({ icon, label, children }) => {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const canBeOpen = open && Boolean(anchorEl);

  const id = canBeOpen ? "data-table-v2-search-transition-popper" : undefined;

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen((previousOpen) => !previousOpen);
  };

  return (
    <>
      <Stack
        direction={"row"}
        sx={{ cursor: "pointer" }}
        alignItems={"center"}
        border={`1px solid ` + theme.palette.grey[500]}
        borderRadius={1}
        width={"100%"}
        spacing={0.5}
        onClick={handleClick}
      >
        <Stack
          direction={"row"}
          pl={0.8}
          flex={2.5}
          alignItems={"center"}
          spacing={0.5}
        >
          {icon}
          <Typography variant="body2" fontWeight={500} pr={1}>
            {label}
          </Typography>
        </Stack>
        <Stack
          flex={1}
          sx={{
            borderLeft: `1px solid ` + theme.palette.grey[500],

            height: 30,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: children ? 1 : 0.1,
            pointerEvents: children ? "auto" : "none",
          }}
          aria-describedby={id}
        >
          <ArrowDropDown />
        </Stack>
      </Stack>
      {children && (
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          sx={{ zIndex: 1200 }}
          onClose={() => setOpen(false)}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          <Paper variant="outlined" sx={{ minWidth: 250, pb: 1 }}>
            <Box padding={1}>
              <Typography variant="h4" fontWeight={600}>
                {children.label}
              </Typography>
              {children.value && (
                <Typography variant="body1" color="primary">
                  {children.value}
                </Typography>
              )}
            </Box>
            <Divider sx={{ mt: 1, mb: 1 }} />
            <List disablePadding>
              {children.menuItems.map((menuItem, index) => {
                return (
                  <ListItemButton
                    key={index}
                    sx={{ p: 0.8 }}
                    onClick={menuItem.onClick}
                  >
                    <ListItemIcon>{menuItem.icon}</ListItemIcon>
                    <ListItemText primary={menuItem.label} />
                  </ListItemButton>
                );
              })}
            </List>
          </Paper>
        </Popover>
      )}
    </>
  );
};
